export default __webpack_public_path__ + "static/media/blog-img68.5d9f11f3.jpg";